import { DynamicWidgetProps } from './dynamicWidgetProp'
import { widgetsProductType } from './ackoDriveWidgetConfig'
import { ackoDriveWidgetReader } from './ackoDriveWidgetReader'

export const RESPONSIVE_WIDGET = ['puc-widget']

const DynamicWidget = ({
  widgetType = '',
  regexPatternsData,
  blogAdWidget,
  setOnWidgetFloaterClick,
}: DynamicWidgetProps) => {
  if (widgetType) {
    const Widget = widgetsProductType[widgetType]
    return (
      <div>
        <Widget
          widgetHeading={ackoDriveWidgetReader.heading(blogAdWidget)}
          widgetCtaText={ackoDriveWidgetReader.ctaText(blogAdWidget)}
          regexPatternsData={regexPatternsData}
          isAckoDrive
          setOnWidgetFloaterClick={setOnWidgetFloaterClick}
        />
      </div>
    )
  }
}

export default DynamicWidget
